(function () {
  'use strict';

  document.addEventListener('loading-screen:show', () => {
    const loading = document.getElementById('loading-screen');
    if (loading) {
      loading.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }
  });

  document.addEventListener('loading-screen:hide', () => {
    const loading = document.getElementById('loading-screen');
    if (loading) {
      loading.style.display = 'none';
      document.body.style.overflow = '';
    }
  });

  /*---------------------------------
    iOS系統のブラウザバック処理の対処
    ローディングを解除する
  ---------------------------------*/
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      document.dispatchEvent(new CustomEvent('loading-screen:hide'));
    }
  });

  /*---------------------------------
    カートページ：商品の増減・削除によるサービス情報欠損抑制処理
  ---------------------------------*/
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('main .cart-page__quantity-wrapper a').forEach(el => {
      el.addEventListener('click', () => {
        document.dispatchEvent(new CustomEvent('loading-screen:show'));
      })
    });
  });
})();
